export default __webpack_public_path__ + "static/media/pot6.791b42ac.svg";